{
    "save": "Save",
    "edit": "Edit",
    "update": "Update",
    "cancel": "Cancel",
    "delete": "Delete",
    "move_to": "Move to",
    "close": "Close",
    "detail": "Detail",
    "copy": "Copy",
    "copied_text": "Copied text",
    "confirm_delete_record_NAME": "Are you sure you want to delete the \":name\" record?",
    "confirm_delete_FIELD_NAME": "Are you sure you want to delete the \":name\" :field?",
    "record_RECORD_doesnt_exist_in_the_TABLE_table": "The record \":record\" does not exist in the :table table",
    "min_MIN_characters_on_search": "Search must be at least :min characters",
    "add_FIELD": "Add :field",
    "see_FIELD": "See :field",
    "edit_FIELD_NAME": "Edit :field \":name\"",
    "the_page": "the page",
    "cannot_save_an_error": "You can't save a mistake",
    "incorrect_blade_format": "Incorrect blade format",
    "to_empty": "To empty",
    "launch": "Launch",
    "correct": "It's right",
    "ok": "Ok",
    "reload_page": "Reload Page",
    "unforeseen_error": "Unforeseen error",
    "loading": "Loading",
    "loading_dots": "Loading...",
    "search": "Search",
    "searching_dots": "Searching...",
    "no_results": "No results",
    "filter": "Filter",
    "date": "Date",
    "download_completed": "Download completed",
    "fetch_error_message": "There was a problem with the FETCH request^:",
    "some_class_does_not_meet_the_INTERFACE_interface_contract": "Some class does not meet the :interface interface contract",
    "it_has_been_called_a_JS_component_that_does_not_match_the_current_page": "It has been called a JS component that does not match the current page",
    "need_NUMBER_characters": "Need :number characters",
    "a_loader_was_expected_on_the_page": "A loader was expected on the page",
    "check_if_the_loader_was_in_a_div": "Check if the loader was in a div. In that case the div ID is required.",
    "you_do_not_have_permissions_to_edit": "You do not have permissions to edit",

    "select_search_placeholder": "Search...",
    "select_search_text": "No Results",
    "select_searching_text": "Searching...",
    "select_results_text": "{count} results available",
    "select_deselect_text": "Clear",
    "select_remove_text": "Remove",
    "select_placeholder_text": "Select value",
    "select_maxValues_message": "{number} selected",
    "select_addable_text": "Press \"Enter\" to add {value}",
    "select_debounce_MIN_characters": "Search must be at least :min characters",
    "select_debounce_empty_results": "No results found"
}
